<template lang="pug">
    .div
        .div(v-if="renderBeforeText")
            | {{ beforeText }} <strong>{{ clockValue | secondsToFullWords }}</strong>
        .div(v-else)
            | <strong>{{ clockValue | secondsToFullWords }}</strong>
</template>

<script lang="ts">
	import Vue from 'vue';

	export default Vue.extend({
        data() {
            return {
                clockInterval: null,
                clockValue: null,
            }
        },
        methods: {
            setClockValue() {
                if (!this.validTimestamp) {
                    return;
                }

                // Init dates
                const d = new Date(this.timestamp);
                const currentTime = new Date();

                // Calculate clock
                this.clockValue = (Math.floor(currentTime.getTime() - d.getTime()) / 1000);

                // Push up
                if (!!this.id) {
                    this.clockValueUpdate(this.id, this.clockValue);
                }
            },
            startClock() {
                this.setClockValue();
                this.clockInterval = setInterval(this.setClockValue, 1000);
            },
            stopClock() {
                if (!this.clockInterval) {
                    return;
                }

                clearInterval(this.clockInterval);
            },
        },
        computed: {
            renderBeforeText() {
                return this.beforeText?.length > 0;
            },
            validTimestamp() {
                if (!this.timestamp) {
                    return false;
                }

                const d = new Date(this.timestamp);
                if (isNaN(d.getTime())) {
                    return false;
                }

                return true;
            },
        },
        components: {
        },
        props: {
            beforeText: String,
            id: Number,
            clockValueUpdate: Function,
            timestamp: String,
        },
        created() {
            if (!this.validTimestamp) {
                return;
            }

            this.startClock();
        },
        destroyed() {
            this.stopClock();
        },
	});
</script>

<style lang="scss" scoped>
</style>
